import { IonContent, IonHeader, IonItem, IonList, IonMenu, IonToolbar } from '@ionic/react'
import React from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps, withRouter } from 'react-router'
import { State } from '../store'
import { logout, logoutType } from '../store/auth'

interface StateProps {
  authenticated: boolean
  user: string
}

interface DispatchProps {
  logout: logoutType
}

type Props = RouteComponentProps& StateProps & DispatchProps

const Menu: React.FC<Props> = props => {
  const menu = React.createRef<any>()
  let content;

  const close = () => {
    if (menu.current) {
      menu.current.setOpen(false)
    }
  }

  if (props.authenticated) {
    content = (
      <IonList>
        <IonItem
          button
          onClick={() => close()}
          routerLink={'/home'}
        >
          Home
        </IonItem>
        <IonItem
          button
          onClick={() => close()}
          routerLink={'/online-ordner/profile'}
        >
          Profil
        </IonItem>
        <IonItem
          button
          onClick={() => close()}
          routerLink={'/online-ordner/contracts'}
        >
          Verträge
        </IonItem>

        <IonItem
          button
          onClick={() => close()}
          routerLink={'/privacy'}
        >
          Datenschutz
        </IonItem>
        <IonItem
          button
          onClick={() => close()}
          routerLink={'/terms'}
        >
          AGB
        </IonItem>

        <IonItem
          style={{
            marginTop: 30
          }}
          button
          onClick={async () => {
            close()
            props.history.push({ pathname: '/home' })
            await props.logout()
          }}
        >
          Abmelden
        </IonItem>
      </IonList>
    )
  } else {
    content = (
      <IonList>
        <IonItem
          button
          routerLink={'/home'}
          onClick={() => close()}
        >
          Home
        </IonItem>

        <IonItem
          button
          onClick={() => close()}
          routerLink={'/privacy'}
        >
          Datenschutz
        </IonItem>
        <IonItem
          button
          onClick={() => close()}
          routerLink={'/terms'}
        >
          AGB
        </IonItem>
        {/*
        <IonItem
          style={{
            marginTop: 30
          }}
          button
          routerLink={'/auth/login'}
          onClick={() => close()}
        >
          Melde dich bitte an
        </IonItem>
        */}
      </IonList>
    )
  }

  return (
    <IonMenu
      ref={menu}
      side="start"
      contentId={'main'}
    >
      <IonHeader>
        <IonToolbar color="primary">
          <img
            src={'assets/icon/icon-transparent.png'}
            alt={'logo'}
            style={{
              maxWidth: '90%',
              height: 200,
              margin: 'auto',
              display: 'block',
            }}
          />
        </IonToolbar>
      </IonHeader>
      <IonContent>
        {content}
      </IonContent>
    </IonMenu>
  )
}

export default connect<StateProps, DispatchProps, {}, State>(
  ({auth}) => ({
    authenticated: auth.authenticated || false,
    user: auth.settings ? auth.settings.username : ''
  }),
  {
    logout,
  }
)(withRouter(Menu))
